<template>
  <div class="product-search">
    <section class="row justify-content-center mt-5 mb-5">
      <div class="col-12 title text-center mb-3">您在尋找什麼？</div>
      <div class="col-xl-6 col-md-8 col-12">
        <div class="row">
          <div class="col">
            <div class="input-group">
              <img class="input-group-text bg-transparent border-0 border-bottom border-dark rounded-0 p-0" src="@/assets/img/ic-search.svg" id="icon-search">
              <input type="text" class="form-control bg-transparent border-0 border-bottom border-dark rounded-0" aria-describedby="icon-search" list="query-list" v-model="query">
              <datalist id="query-list" v-if="queryOptions">
                <option v-for="(option, index) in queryOptions" :key="`qo-${index}`" :value="option"/>
              </datalist>
            </div>
          </div>
          <!--
          <div class="col-auto">
            <button class="btn btn-dark rounded-0 ps-4 pe-4" @click="apiSearchProducts">搜尋</button>
          </div>
          -->
        </div>
      </div>
    </section>
    <section class="pt-5 pb-5">
      <product-grid :products="products" v-if="query && query.length >= 2"/>
    </section>
  </div>
</template>

<script>
import constant from '@/constant.js'
import { mapGetters, mapMutations } from 'vuex'
import productApi from '@/api/product.js'
import ProductGrid from '@/components/Product/ProductGrid.vue'

export default {
  name: 'ProductSearch',
  components: {
    ProductGrid
  },
  data: function () {
    return {
      query: null,
      timeoutId: null,
      products: []
    }
  },
  computed: {
    ...mapGetters([
      'keywords'
    ]),
    queryOptions: function () {
      if (!this.keywords || !this.query || this.query.length < 2) {
        return null
      }
      return this.keywords.filter(e => e.indexOf(this.query) >= 0).filter((v, i, a) => (a.indexOf(v) === i)).slice(0, 10)
    }
  },
  watch: {
    '$route.params.inputQuery': function (value) {
      this.query = value
    },
    query: function (value) {
      clearTimeout(this.timeoutId)
      if (value && value.length >= 2) {
        var self = this
        this.timeoutId = setTimeout(() => { self.apiSearchProducts() }, 1000)
      } else {
        this.products = []
      }
    }
  },
  mounted: function () {
    if (this.$route.params.inputQuery) {
      this.query = this.$route.params.inputQuery
    }
  },
  methods: {
    ...mapMutations([
      'signOut'
    ]),
    apiSearchProducts: function () {
      var self = this
      productApi.search(this.query, null, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.products = rspData
      })
    }
  }
}
</script>

<style scoped>
.title {
  font-family: 'Noto Serif TC', serif;
  font-size: 1.9rem;
  font-weight: 700;
}
</style>
